import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LocationSelectSharedComponent } from './location-select.component';
import { JumbotronSharedModule } from '../../molecules/jumbotron/jumbotron.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectSharedModule } from '../../molecules/select/select.module';
import { ButtonSharedModule } from '../../atoms/button/button.module';
import { InputSharedModule } from '../../molecules/input/input.module';

@NgModule({
    declarations: [
        LocationSelectSharedComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,

        ButtonSharedModule,
        InputSharedModule,
        JumbotronSharedModule,
        SelectSharedModule,
    ],
    exports: [
        LocationSelectSharedComponent
    ],
})

export class LocationSelectSharedModule {}
